// extracted by mini-css-extract-plugin
export default {"link":"Logo_link__au1AS","logo":"Logo_logo__Yt1-+"};